import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, retry, switchMap, throwError } from 'rxjs';
import { NetworkStatusService } from '../../network/network-status.service';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { BYPASS_OFFLINE_GATE } from './offline-http-context';
import { isOfflineGateRequest } from './offline-request-classifier';

export const offlineGateInterceptor: HttpInterceptorFn = (req, next) => {
  const network = inject(NetworkStatusService);
  const appConfiguration = inject(AppConfiguration);

  if (req.context.get(BYPASS_OFFLINE_GATE) || !isOfflineGateRequest(req, appConfiguration)) {
    return next(req);
  }

  return network.waitUntilOnline().pipe(
    switchMap(() =>
      next(req).pipe(
        retry({
          delay: (error: unknown) => {
            if (!(error instanceof HttpErrorResponse) || error.status !== 0) {
              return throwError(() => error);
            }

            return from(network.confirmOfflineAfterFailure()).pipe(
              switchMap(isOffline => {
                if (!isOffline) {
                  return throwError(() => error);
                }

                return network.waitUntilOnline();
              })
            );
          },
        })
      )
    )
  );
};
